import React from 'react';
import { formatPhone } from '../utils/phoneFormat';

// Drop-in replacement for <input type="tel">. Formats as you type to (XXX) XXX-XXXX and passes the
// formatted value to onChange in a normal-looking event (target.name and target.value), so existing
// handlers keep working. Existing saved numbers are shown formatted but are not rewritten until edited.
export default function PhoneInput({ value, onChange, ...rest }) {
  const handle = (e) => {
    const formatted = formatPhone(e.target.value);
    if (!onChange) return;
    const target = { name: e.target.name, id: e.target.id, type: 'tel', value: formatted };
    onChange({ target, currentTarget: target, preventDefault: () => {}, stopPropagation: () => {}, nativeEvent: e.nativeEvent });
  };
  const shown = value ? (formatPhone(value) || value) : '';
  return <input type="tel" inputMode="tel" autoComplete="tel" placeholder="(239) 555-1234" {...rest} value={shown} onChange={handle} />;
}
